/**
 * Job Offers Manager - Moon Moon Agency
 * Gère l'ouverture/fermeture des modales de détail des offres d'emploi
 */

/*********************************************************************************************
 * 🔧 JOB OFFERS MANAGER
 */
const JobOffersManager = {
	config: {
		selectors: {
			trigger: '[data-job-offers-open]',
			close: '[data-job-offers-close]',
			overlay: '[data-job-offers-overlay]',
			modal: '[data-job-offers-modal]',
			focusable: 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
		},
	},

	activeModal: null,
	activeTrigger: null,

	init() {
		const overlay = document.querySelector(this.config.selectors.overlay);
		if (!overlay) return; // Guard clause : sortie silencieuse si absent du DOM

		this._bindEvents();
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.selectors.trigger);
			if (trigger) {
				e.preventDefault();
				this.open(trigger);
				return;
			}

			if (e.target.closest(this.config.selectors.close) || e.target.matches(this.config.selectors.overlay)) {
				this.close();
			}
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.activeModal) this.close();
			if (e.key === 'Tab' && this.activeModal) this._trapFocus(e);
		});
	},

	open(trigger) {
		const targetId = trigger.dataset.jobOffersTarget;
		const modal = document.getElementById(targetId);
		if (!modal) return;

		this.activeModal = modal;
		this.activeTrigger = trigger;

		modal.hidden = false;
		document.querySelector(this.config.selectors.overlay).hidden = false;
		document.body.classList.add('mm-job-offers-no-scroll');

		const closeBtn = modal.querySelector(this.config.selectors.close);
		if (closeBtn) closeBtn.focus();
	},

	close() {
		if (!this.activeModal) return;

		this.activeModal.hidden = true;
		document.querySelector(this.config.selectors.overlay).hidden = true;
		document.body.classList.remove('mm-job-offers-no-scroll');

		if (this.activeTrigger) this.activeTrigger.focus();

		this.activeModal = null;
		this.activeTrigger = null;
	},

	_trapFocus(e) {
		const focusableElements = this.activeModal.querySelectorAll(this.config.selectors.focusable);
		if (!focusableElements.length) return;

		const first = focusableElements[0];
		const last = focusableElements[focusableElements.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => JobOffersManager.init());
} else {
	JobOffersManager.init();
}
